import { Component, ElementRef, ChangeDetectorRef, OnInit } from '@angular/core';
import { MatDialog} from '@angular/material/dialog';
import { SharedService } from './back-office/modules/shared-service.service';
import { ApiServiceModule } from './back-office/modules/api-service.module';
import { HelperModule } from './back-office/modules/helper.module';
import config from 'config/default.json';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(private elRef:ElementRef, private cdRef: ChangeDetectorRef,
    private sharedService: SharedService,
    private apiService: ApiServiceModule,
    private helper: HelperModule,
    public dialog: MatDialog) {}

  urlDomain = window.location.hostname;
  route:string = window.location.href.split('/').at(-1) ?? '';
  epanelPrivateRoutes:string[] = ['connect', 'pdf-to-docx'];
  subDomain:string = '';
  title = 'back-office';

  enovskyDomain = 'enovsky.com';
  chatDomain = 'chat.enovsky.com';
  backOfficeDomain = 'back-office.enovsky.com';
  backOfficeStagingDomain = 'staging.enovsky.com';
  epanelDomain = 'epanel.enovsky.com';
  drawDomain = 'draw.enovsky.com';

 
  isLoggin = true
  isBackOfficeConnected = false;
  isEpanelConnected = false;
  
  isRegistration = false;
  userInfos:any;
  
  
  
  ngOnInit(){
    if(this.urlDomain == this.epanelDomain && !this.epanelPrivateRoutes.includes(this.route) && this.route != 'connect'){
      this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/administration/user_basic_infos', {}, '').subscribe((response:any)=>{
        //this.helper.showToast(response.message);
        if(response.status){
          let userInfos = response.user_infos;
          if(userInfos && userInfos.authorized){
            this.isEpanelConnected = true;
            this.isRegistration = false;
            this.isLoggin = false;
            this.isBackOfficeConnected = true;
            this.userInfos = userInfos;
            this.userInfos['service'] = this.route;
            this.cdRef.detectChanges();
          }
        }else this.helper.showToast(response.message);
      })
      /* const token = this.getCookie('access_token_mobile');
      if (token) {
        this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/administration/user_login_token', {token: token}, token).subscribe((response:any)=>{
        //this.helper.showToast(response.message);
        if(response.status){
          let userInfos = response.user_infos;
          if(userInfos && userInfos.authorized){
            this.isEpanelConnected = true;
            this.isRegistration = false;
            this.isLoggin = false;
            this.isBackOfficeConnected = true;
            this.userInfos = userInfos;
            this.cdRef.detectChanges();
          }
        }else this.helper.showToast(response.message);
      })
      } */
    }
    
  }
    
  connexionAuthenticated(userInfos: any){
    if(this.urlDomain == this.epanelDomain){
      this.isEpanelConnected = true;
      this.isBackOfficeConnected = true;
    }
    if(this.urlDomain == this.backOfficeDomain){
      if(userInfos && userInfos.authorized && userInfos.privilege > 1){
        this.isEpanelConnected = false;
        this.isBackOfficeConnected = true;
      }
    }
    this.isRegistration = false;
    this.isLoggin = false;
    this.userInfos = userInfos;
    this.userInfos['service'] = this.route;
    this.cdRef.detectChanges();
  }
  checkUserConnexion(userInfos:any){
    
  }
  createNewUser(){
    this.isLoggin = false;
    this.isRegistration = true;
  }
  connectUser(){
    this.isRegistration = false;
    this.isLoggin = true;
  }
  getCookie(key: string){
    const matches = document.cookie.match(
      new RegExp('(?:^|; )' + key + '=([^;]*)')
    );
    return matches ? decodeURIComponent(matches[1]) : null;
  };

  
}
